import { render } from "./ProgramDetail.vue?vue&type=template&id=1931fc94&scoped=true"
import script from "./ProgramDetail.vue?vue&type=script&lang=js"
export * from "./ProgramDetail.vue?vue&type=script&lang=js"

import "./ProgramDetail.vue?vue&type=style&index=0&id=1931fc94&scoped=true&lang=css"

import exportComponent from "/Volumes/Evolve/WorkSpace/MinonowaRadio/Ver2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1931fc94"]])

export default __exports__